import {configureStore, ThunkAction, Action, combineSlices} from '@reduxjs/toolkit';
import language_slice from "@/app/utils/language_slice";
import unread_count_slice from "@/app/features/unread_count/slice";
import adminCourts from "@/admin/store/adminCourtsSlice";
import adminMatches from "@/admin/store/adminMatchesSlice";
import adminUsers from "@/admin/store/adminUsersSlice";

const rootReducer = combineSlices(language_slice, unread_count_slice, adminCourts, adminMatches, adminUsers);

export const store = configureStore({
    reducer: rootReducer
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
